import React from "react";
import PropTypes from "prop-types";
import Header from "../Header";
import "./HuiBigCard.scss";

export const HuiBigCard = ({ title, subtitle, bigLabels, ...props }) => {
  return (
    <div
      className={`hireart-ds-big-card ${
        bigLabels === true ? "big-labels" : ""
      }`}
    >
      <div className="big-card-header">
        <Header size="h3" text={title} />
        {subtitle}
      </div>
      <div className="big-card-content">{props.children}</div>
    </div>
  );
};

HuiBigCard.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  bigLabels: PropTypes.bool,
};

